var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLaneChangeLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6E625E;stroke:#FAF9F7;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,76.4v-12c0-1-0.2-2-0.5-2.9c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.3-0.3-0.5-0.4-0.7 s-0.2-0.4-0.3-0.5c-1.7-2.5-4.6-4.1-7.8-4.1l0.1,0c-0.9,0-1.8,0-2.7-0.2c-0.9-0.1-1.9-0.3-2.8-0.5c-2.6-0.6-5-1.7-7.2-3.1 c-1.4-0.9-2.6-1.9-3.8-3c-0.2-0.2-0.5-0.5-0.7-0.8c-0.2-0.2-0.5-0.5-0.7-0.8c-0.3-0.4-0.7-0.8-1-1.3c-0.1-0.2-0.2-0.4-0.4-0.5 c-0.6-0.8-1.1-1.7-1.5-2.6c-0.2-0.3-0.3-0.6-0.5-1c-0.2-0.4-0.4-0.9-0.5-1.3c-0.3-0.8-0.6-1.6-0.8-2.4l0,0c-0.2-0.6-0.3-1.3-0.4-1.9 c-0.2-1.2-0.3-2.4-0.3-3.7l0.1-9.7H8.6L27.2,3.2L45.9,22l-11.3,0.2l0,9c0,4,2.4,7.4,5.9,8.7c0.5,0.2,1,0.4,1.6,0.5c0,0,0.1,0,0.2,0 c0.6,0.1,1.2,0.2,1.8,0.2l0.1,0c0.5,0,0.9,0,1.4,0c0.3,0,0.7,0.1,1,0.1c0.4,0,0.8,0.1,1.2,0.1c7.5,1.1,13.8,5.8,17.1,12.3 c1.5,2.8,2.4,6,2.6,9.3c0,0.4,0,0.9,0,1.3v12.7H53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLaneChangeLeft);
export default __webpack_public_path__ + "static/media/arrow-lane-change-left.6fed37d73033ac6213b7046dc6915420.svg";
export { ForwardRef as ReactComponent };